import React from "react"
import { DashboardPage } from "./pages/DashboardPage"
import { ReportingPage } from "./modules/Reporting/ReportingPage"
import { shallowEqual, useSelector } from "react-redux"
import { ContactTracingPage } from "./modules/Admin/contact-tracing/ContactTracingPage"
import { SvgIcon } from "@material-ui/core"
import LockOpenIcon from "@material-ui/icons/LockOpen"

export default function Pages() {
	const { selectedSite, userClaims, pageOptions } = useSelector(
		state => ({
			selectedSite: state.profile?.currentSite,
			userClaims: state.auth.claims,
			pageOptions: state.profile?.currentSite?.options?.pages
		}),
		shallowEqual
	)

	const siteFinished = selectedSite?.siteInfo?.siteFinished || null

	const pages = [
		{
			name: "Dashboard",
			icon: <HomeIcon />,
			path: "/dashboard",
			component: DashboardPage
		},
		selectedSite && {
			name: "Reporting",
			icon: <ReportingIcon />,
			path: "/reporting",
			component: ReportingPage
		},
		selectedSite &&
			userClaims?.profileLvl >= 4 && {
				name: "Audit Tool",
				icon: <AuditIcon />,
				path: "/audit-tool",
				component: ContactTracingPage
			},
		selectedSite &&
			userClaims?.profileLvl >= 2 && {
				name: "Admin",
				icon: <LockOpenIcon />,
				path: "/admin",
				subpages: [
					userClaims?.profileLvl >= 4 &&
						!siteFinished && {
							name: "Customer Onboarding",
							path: "/admin/customer-on-boarding"
						},
					pageOptions?.peopleOnboarding &&
						!siteFinished && {
							name: "People Onboarding",
							path: "/admin/people-onboarding"
						},
					!siteFinished && {
						name: "Design Studio",
						path: "/admin/design-studio"
					},
					{
						name: "Manage Customer",
						path: "/admin/manage-customer"
					},
					!siteFinished && {
						name: "Manage Site",
						path: "/admin/manage-site"
					}

					// {
					// 	name: "Inventory",
					// 	path: "/admin/inventory"
					// }
				].filter(val => val)
			},
		selectedSite &&
			userClaims?.profileLvl >= 4 && {
				name: "Operations",
				icon: <OperationsIcon />,
				path: "/operations",
				subpages: [
					{
						name: "Inventory",
						path: "/operations/inventory"
					},
					{
						name: "Manage Infrastructure",
						path: "/operations/manage-infrastructure"
					}
				].filter(val => val)
			}
	].filter(val => val)

	return pages
}

function HomeIcon(props) {
	return (
		<SvgIcon {...props}>
			<svg
				width="19"
				height="20"
				viewBox="0 0 19 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="home">
					<path
						id="Vector"
						d="M9.86355 2.30159C9.75816 2.21935 9.62831 2.17468 9.49463 2.17468C9.36094 2.17468 9.23109 2.21935 9.1257 2.30159L0.59375 8.95492L1.3316 9.88811L2.375 9.07456V16.4246C2.37564 16.7394 2.50096 17.0411 2.72352 17.2636C2.94608 17.4862 3.24775 17.6115 3.5625 17.6121H15.4375C15.7523 17.6116 16.054 17.4863 16.2765 17.2637C16.4991 17.0411 16.6244 16.7394 16.625 16.4246V9.07996L17.6684 9.8934L18.4062 8.96014L9.86355 2.30159ZM10.6875 16.4246H8.3125V11.6746H10.6875V16.4246ZM11.875 16.4246V11.6746C11.8746 11.3598 11.7494 11.058 11.5268 10.8354C11.3042 10.6127 11.0023 10.4875 10.6875 10.4871H8.3125C7.99765 10.4875 7.69579 10.6127 7.47316 10.8353C7.25053 11.0579 7.12531 11.3598 7.125 11.6746V16.4246H3.5625V8.14866L9.5 3.52335L15.4375 8.1549V16.4246H11.875Z"
						fill="#8C8CA1"
					/>
				</g>
			</svg>
		</SvgIcon>
	)
}

function ReportingIcon(props) {
	return (
		<SvgIcon {...props}>
			<svg
				width="18"
				height="18"
				viewBox="0 0 18 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="chart--ring">
					<path
						id="Vector"
						d="M8.70405 0.177673C7.01771 0.177673 5.36923 0.677733 3.96709 1.61462C2.56494 2.5515 1.4721 3.88313 0.826765 5.44111C0.181429 6.99909 0.0125792 8.71345 0.341569 10.3674C0.670559 12.0213 1.48261 13.5406 2.67504 14.733C3.86746 15.9254 5.38671 16.7375 7.04065 17.0665C8.69459 17.3955 10.409 17.2266 11.9669 16.5813C13.5249 15.9359 14.8565 14.8431 15.7934 13.441C16.7303 12.0388 17.2304 10.3903 17.2304 8.70399C17.2278 6.44345 16.3287 4.27623 14.7303 2.67779C13.1318 1.07934 10.9646 0.18022 8.70405 0.177673ZM15.9814 8.09557H12.3034C12.2019 7.48531 11.9467 6.91094 11.5618 6.4266C11.1769 5.94226 10.675 5.56389 10.1035 5.32716C9.53192 5.09043 8.9095 5.00313 8.29487 5.07349C7.68024 5.14386 7.09365 5.36956 6.59038 5.72934L3.98985 3.12881C5.01262 2.26064 6.25498 1.69131 7.58033 1.48342C8.90568 1.27554 10.2627 1.43715 11.5021 1.95048C12.7416 2.46381 13.8155 3.30899 14.6058 4.39308C15.396 5.47717 15.8721 6.75818 15.9815 8.09527L15.9814 8.09557ZM8.70405 11.1401C8.22224 11.1401 7.75125 10.9972 7.35063 10.7295C6.95002 10.4618 6.63778 10.0814 6.4534 9.63624C6.26902 9.1911 6.22077 8.70129 6.31477 8.22873C6.40877 7.75617 6.64078 7.3221 6.98148 6.98141C7.32217 6.64072 7.75624 6.4087 8.22879 6.31471C8.70135 6.22071 9.19117 6.26895 9.6363 6.45333C10.0814 6.63772 10.4619 6.94996 10.7296 7.35057C10.9973 7.75118 11.1401 8.22217 11.1401 8.70399C11.1394 9.34986 10.8825 9.96906 10.4258 10.4258C9.96913 10.8825 9.34992 11.1394 8.70405 11.1401ZM1.39578 8.70399C1.39512 6.97673 2.00946 5.30567 3.12876 3.99015L5.72928 6.59037C5.36963 7.09367 5.14401 7.68023 5.07368 8.29481C5.00335 8.90939 5.09062 9.53176 5.32728 10.1033C5.56394 10.6748 5.94219 11.1767 6.4264 11.5617C6.91062 11.9466 7.48486 12.202 8.09503 12.3037V15.9822C6.26991 15.8281 4.56901 14.9948 3.32857 13.6472C2.08813 12.2996 1.39842 10.5356 1.39578 8.70399ZM9.31307 15.9818V12.3033C10.0598 12.1758 10.7484 11.8196 11.2841 11.284C11.8197 10.7484 12.1759 10.0597 12.3034 9.31301H15.9819C15.836 11.0328 15.0865 12.6455 13.866 13.866C12.6456 15.0864 11.0329 15.8359 9.31307 15.9818Z"
						fill="#8C8CA1"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4926_1832">
						<rect width="18" height="18" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</SvgIcon>
	)
}

function AuditIcon(props) {
	return (
		<SvgIcon {...props}>
			<svg
				width="22"
				height="22"
				viewBox="0 0 20 21"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="license--third-party">
					<path
						id="Vector"
						d="M3.75 19.6981H8.75V18.4481H3.75V3.44806H13.75V9.69806H15V3.44806C14.9997 3.11665 14.8678 2.7989 14.6335 2.56456C14.3992 2.33021 14.0814 2.19841 13.75 2.19806H3.75C3.41859 2.19841 3.10085 2.33021 2.8665 2.56456C2.63216 2.7989 2.50035 3.11665 2.5 3.44806V18.4481C2.50035 18.7795 2.63216 19.0972 2.8665 19.3316C3.10085 19.5659 3.41859 19.6977 3.75 19.6981ZM12.5 4.69806H5V5.94806H12.5V4.69806ZM8.75 9.69806H5V10.9481H8.75V9.69806ZM5 7.19806H12.5V8.44806H5V7.19806ZM8.75 15.9481H5V17.1981H8.75V15.9481ZM16.875 16.5731C17.3723 16.5731 17.8492 16.7706 18.2008 17.1222C18.5525 17.4739 18.75 17.9508 18.75 18.4481V19.6981H17.5V18.4481C17.5 18.2823 17.4342 18.1233 17.3169 18.0061C17.1997 17.8889 17.0408 17.8231 16.875 17.8231H13.125C12.9592 17.8231 12.8003 17.8889 12.6831 18.0061C12.5658 18.1233 12.5 18.2823 12.5 18.4481V19.6981H11.25V18.4481C11.25 17.9508 11.4475 17.4739 11.7992 17.1222C12.1508 16.7706 12.6277 16.5731 13.125 16.5731H16.875ZM15 15.9481C15.4945 15.9481 15.9778 15.8014 16.3889 15.5267C16.8 15.252 17.1205 14.8616 17.3097 14.4048C17.4989 13.948 17.5484 13.4453 17.452 12.9603C17.3555 12.4754 17.1174 12.0299 16.7678 11.6803C16.4181 11.3307 15.9727 11.0926 15.4877 10.9961C15.0028 10.8996 14.5001 10.9491 14.0433 11.1384C13.5865 11.3276 13.196 11.648 12.9213 12.0591C12.6466 12.4703 12.5 12.9536 12.5 13.4481C12.5 14.1111 12.7634 14.747 13.2322 15.2158C13.7011 15.6847 14.337 15.9481 15 15.9481ZM15 12.1981C15.2472 12.1981 15.4889 12.2714 15.6945 12.4087C15.9 12.5461 16.0602 12.7413 16.1549 12.9697C16.2495 13.1981 16.2742 13.4494 16.226 13.6919C16.1778 13.9344 16.0587 14.1571 15.8839 14.3319C15.7091 14.5068 15.4863 14.6258 15.2439 14.674C15.0014 14.7223 14.7501 14.6975 14.5216 14.6029C14.2932 14.5083 14.098 14.3481 13.9607 14.1425C13.8233 13.937 13.75 13.6953 13.75 13.4481C13.75 13.1165 13.8817 12.7986 14.1161 12.5642C14.3505 12.3298 14.6685 12.1981 15 12.1981Z"
						fill="none"
					/>
				</g>
			</svg>
		</SvgIcon>
	)
}

function OperationsIcon(props) {
	return (
		<SvgIcon {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="21"
				viewBox="0 0 20 21"
				fill="none"
			>
				<g id="operations-id">
					<path
						d="M18.3215 15.4611V14.2111H17.0083C16.9278 13.8198 16.7724 13.4479 16.5509 13.1155L17.4822 12.1842L16.5984 11.3005L15.6672 12.2317C15.3348 12.0102 14.9628 11.8548 14.5715 11.7742V10.4611H13.3215V11.7742C12.9303 11.8548 12.5583 12.0102 12.226 12.2317L11.2947 11.3004L10.411 12.1842L11.3422 13.1154C11.1207 13.4478 10.9653 13.8198 10.8847 14.2111H9.57153V15.4611H10.8847C10.9653 15.8523 11.1206 16.2243 11.3422 16.5566L10.4109 17.4879L11.2947 18.3716L12.2259 17.4404C12.5583 17.6619 12.9303 17.8173 13.3215 17.8979V19.2111H14.5715V17.8979C14.9627 17.8173 15.3347 17.662 15.6671 17.4404L16.5983 18.3717L17.4821 17.4879L16.5508 16.5567C16.7724 16.2243 16.9277 15.8523 17.0083 15.4611H18.3215ZM13.9465 16.7111C13.5757 16.7111 13.2132 16.6011 12.9048 16.3951C12.5965 16.189 12.3562 15.8962 12.2143 15.5536C12.0723 15.211 12.0352 14.834 12.1076 14.4703C12.1799 14.1066 12.3585 13.7725 12.6207 13.5102C12.8829 13.248 13.217 13.0694 13.5807 12.9971C13.9445 12.9247 14.3215 12.9619 14.6641 13.1038C15.0067 13.2457 15.2995 13.486 15.5055 13.7944C15.7116 14.1027 15.8215 14.4652 15.8215 14.8361C15.821 15.3332 15.6233 15.8098 15.2718 16.1613C14.9202 16.5128 14.4436 16.7105 13.9465 16.7111Z"
						fill="#2673F0"
					/>
					<path
						d="M14.9189 3.1694H13.0439V2.5444C13.043 2.21318 12.911 1.89579 12.6768 1.66158C12.4426 1.42736 12.1252 1.29536 11.7939 1.2944H6.79394C6.46272 1.29536 6.14533 1.42736 5.91112 1.66158C5.6769 1.89579 5.5449 2.21318 5.54395 2.5444V3.1694H3.66895C3.33772 3.17036 3.02033 3.30236 2.78612 3.53658C2.5519 3.77079 2.4199 4.08818 2.41895 4.4194V17.5444C2.4199 17.8756 2.5519 18.193 2.78612 18.4272C3.02033 18.6614 3.33772 18.7934 3.66895 18.7944H8.04394V17.5444H3.66895V4.4194H5.54395V6.2944H13.0439V4.4194H14.9189V8.1694H16.1689V4.4194C16.168 4.08818 16.036 3.77079 15.8018 3.53658C15.5676 3.30236 15.2502 3.17036 14.9189 3.1694ZM11.7939 5.0444H6.79394V2.5444H11.7939V5.0444Z"
						fill="#2673F0"
					/>
				</g>
			</svg>
		</SvgIcon>
	)
}
